// extracted by mini-css-extract-plugin
module.exports = {"pageContainer":"Page-module--pageContainer--2iaFX"};